import { FadeIn, SectionHeader } from "../components/Motion";

const PARAS = [
  "Shelf Sense was founded by Srimathi Jayaraman, a Food Scientist with a technical background in Food Science and Technology.",
  "After speaking with food founders, QA managers, and co-manufacturers across Australia, she identified a gap in how shelf-life estimation is determined — it is either too expensive or too slow.",
  "Shelf Sense exists to change that. Every report is built on established predictive models, peer-reviewed literature, and real food science expertise — not guesswork.",
];

const About = () => (
  <section id="about" data-testid="about-section" className="relative py-28 sm:py-36">
    <div className="pointer-events-none absolute left-1/2 top-0 h-[300px] w-[600px] -translate-x-1/2 rounded-full bg-purple-600/8 blur-[120px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <FadeIn>
            <div className="spotlight-frame relative overflow-hidden rounded-[2rem]">
              <img
                src="https://images.unsplash.com/photo-1605781231474-f60dea478e8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxmb29kJTIwc2NpZW5jZSUyMGxhYm9yYXRvcnklMjByZXNlYXJjaHxlbnwwfHx8fDE3OTEwMjY4MTV8MA&ixlib=rb-4.1.0&q=85"
                alt="Qualified food scientist evaluating a shelf-life estimation report"
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
                data-testid="about-image"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0B0812] via-[#0B0812]/70 to-transparent p-6 pt-24">
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full border border-green-400/40 bg-slate-950/80 font-display text-sm font-bold text-green-300">
                    SJ
                  </span>
                  <div>
                    <p className="font-display text-base font-semibold text-slate-50">Srimathi Jayaraman</p>
                    <p className="font-mono text-xs uppercase tracking-[0.2em] text-green-300">Founder · Food Scientist</p>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        <div className="lg:col-span-7">
          <SectionHeader index="05" label="About Shelf Sense" title="Food science expertise, without the lab-sized invoice." />
          <div className="mt-10 space-y-7">
            {PARAS.map((p, i) => (
              <FadeIn key={i} delay={0.15 + i * 0.1}>
                <p className="max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">{p}</p>
              </FadeIn>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
